// this is an autogenerated file from App/Account/EmbeddableCoreMessageListener/PaymentsCreateClaim/Charges/Charge/Type/Content/AddInsuranceCode/Content/InsuranceCode/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_EmbeddableCoreMessageListener_PaymentsCreateClaim_Charges_Charge_Type_Content_AddInsuranceCode_Content_InsuranceCode{
  vaxiom_insurance_codes(
    where: { deleted: { _eq: false } }
    order_by: { code: asc_nulls_last, title: asc_nulls_last }
  ) {
    id
    code
    title
  }
}

`